<template>
  <v-card>
    <v-toolbar color="white" flat>
        <v-toolbar-title class="mx-4">Danh sách tài khoản</v-toolbar-title>
        <v-spacer></v-spacer>
        
        <cfm-dialog :dialog="cfmDialog" :item="selectItem" @close-cfm-dialog="cfmDialog=false, selectItem=null"></cfm-dialog>
        <v-menu
            left
            bottom offset-y
        >
            <template v-slot:activator="{ on, attrs }">
                <v-btn outlined color="success" class="ml-2"
                    v-bind="attrs"
                    v-on="on"
                >
                    Hành động<v-icon>mdi-chevron-down</v-icon>
                </v-btn>
            </template>

            <v-list>
            <v-list-item @click="ipDialog=true">
                <v-list-item-icon>
                  <v-icon color="primary" right>mdi-plus</v-icon>
                </v-list-item-icon>
                <v-list-item-title>Thêm phiếu </v-list-item-title>
            </v-list-item>
            </v-list>
        </v-menu>
    </v-toolbar>
    <v-card-text>
      <v-text-field block outlined dense hide-details prepend-inner-icon="mdi-magnify" v-model="search" placeholder="Tìm kiếm"></v-text-field>
      <v-data-table 
        :items="users"
        :headers="headers"
        :search="search"
        :sort-desc="['deptType']"
        @contextmenu:row.prevent="rowRightClickHandler"
      >
      <template v-slot:[`item.actions`]={item}>
        <v-btn color="primary" block @click="cfmDialog=true, selectItem=item" small class="ma-2">Chuyển thiết bị</v-btn>
        <v-btn color="teal" block @click="setFaceAllow(item)" small class="ma-2">Đăng ký gương mặt</v-btn>
        <v-btn color="teal" outlined block small class="ma-2" @click="addWebHandler(item)">Chấm công web</v-btn>
        <v-btn color="red" outlined block small class="ma-2" @click="selectItem=item, changePasswordDialog = true">Cập nhật mật khẩu</v-btn>
        <v-btn color="indigo" outlined block small class="ma-2" @click="showRotationHistory(item)">Lịch sử điều chuyển</v-btn>
      </template>
      </v-data-table>

      <!-- right click menu -->
      <!-- <r-click-menu :showMenu="rClickMenu" :x="rClickMenuX" :y="rClickMenuY" @open-ip-dialog="openIpDialogHandler" @close-rclick-menu="rClickMenu=false"></r-click-menu>
      <ip-dialog :show="ipDialog" :form="formIp" :ipList="ipList" :selectItem="selectItem" @close="ipDialog=false"></ip-dialog> -->

    </v-card-text>

    <v-dialog v-model="changePasswordDialog" width="600">
      <v-card>
        <v-card-title>Thay đổi mật khẩu</v-card-title>
        <v-card-text>
          <v-form ref="it_change_password" id="it_change_password" v-model="itChangePasswordValid" @submit.prevent="changePasswordHandler">
            <v-row>
              <v-col cols="12">
                <v-text-field outlined persistent-placeholder hide-details="auto" :rules="[v=>!!v || 'Nhập dữ liệu này']" v-model="changePasswordForm.password" label="Mật khẩu" type="password"></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field outlined persistent-placeholder hide-details="auto" :rules="[v=>!!v || 'Nhập dữ liệu này']" v-model="changePasswordForm.confirmPassword" label="Mật khẩu" type="password"></v-text-field>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions class="justify-center">
          <v-btn type="button" color="red" outlined @click="changePasswordDialog = false">Hủy</v-btn>
          <v-btn type="submit" form="it_change_password" color="success">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="rotationDialog" width="1000" scrollable>
      <v-card>
        <v-card-title class="headline grey lighten-2 font-weight-bold">
          Lịch sử điều chuyển: {{ selectItem ? selectItem.employeeName : '' }} ({{ selectItem ? selectItem.employeeCode : '' }})
          <v-spacer></v-spacer>
          <v-btn icon @click="rotationDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pt-4">
          <v-data-table
            :headers="rotationHeaders"
            :items="rotationHistory"
            :loading="rotationLoading"
            loading-text="Đang tải dữ liệu..."
            no-data-text="Không có lịch sử điều chuyển cho nhân viên này"
            class="elevation-1"
            dense
          >
            <!-- Format dates -->
            <template v-slot:[`item.rotationDate`]="{ item }">
              {{ formatDate(item.rotationDate) }}
            </template>
            <template v-slot:[`item.rotation_date`]="{ item }">
              {{ formatDate(item.rotation_date) }}
            </template>
            <template v-slot:[`item.effectDate`]="{ item }">
              {{ formatDate(item.effectDate) }}
            </template>
            <template v-slot:[`item.effect_date`]="{ item }">
              {{ formatDate(item.effect_date) }}
            </template>
            <template v-slot:[`item.applyDate`]="{ item }">
              {{ formatDate(item.applyDate) }}
            </template>
            <template v-slot:[`item.apply_date`]="{ item }">
              {{ formatDate(item.apply_date) }}
            </template>
            <template v-slot:[`item.date`]="{ item }">
              {{ formatDate(item.date) }}
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" outlined @click="rotationDialog = false">Đóng</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import UserService from '../../services/UserService'
import CfmDialog from './CfmDialog.vue'
// import HelpDialog from './HelpDialog.vue'
// import RClickMenu from './RClickMenu.vue'
// import IpDialog from './IpDialog.vue'
export default {
  components:{
    CfmDialog
    // HelpDialog,
    // RClickMenu,
    // IpDialog
  },

  watch: {
    changePasswordDialog(val) {
      if(!val) {
        this.selectItem = {}
        this.changePasswordForm = {
          password: '',
          confirmPassword: '',
          oldPassword:'oldpass'
        }
      }
    }
  },

  computed: {
    rotationHeaders() {
      if (!this.rotationHistory || this.rotationHistory.length === 0) return [];
      
      const labelMap = {
        decisionNo: 'Số quyết định',
        decision_no: 'Số quyết định',
        soQuyetDinh: 'Số quyết định',
        so_quyet_dinh: 'Số quyết định',
        rotationDate: 'Ngày điều chuyển',
        rotation_date: 'Ngày điều chuyển',
        ngayDieuChuyen: 'Ngày điều chuyển',
        ngay_dieu_chuyen: 'Ngày điều chuyển',
        effectDate: 'Ngày hiệu lực',
        effect_date: 'Ngày hiệu lực',
        applyDate: 'Ngày áp dụng',
        apply_date: 'Ngày áp dụng',
        date: 'Ngày',
        oldDepartmentName: 'Phòng ban cũ',
        old_department_name: 'Phòng ban cũ',
        oldDeptName: 'Phòng ban cũ',
        old_dept_name: 'Phòng ban cũ',
        oldDepartment: 'Phòng ban cũ',
        fromDepartment: 'Phòng ban cũ',
        newDepartmentName: 'Phòng ban mới',
        new_department_name: 'Phòng ban mới',
        newDeptName: 'Phòng ban mới',
        new_dept_name: 'Phòng ban mới',
        newDepartment: 'Phòng ban mới',
        toDepartment: 'Phòng ban mới',
        oldPositionName: 'Chức vụ cũ',
        old_position_name: 'Chức vụ cũ',
        oldPosition: 'Chức vụ cũ',
        fromPosition: 'Chức vụ cũ',
        newPositionName: 'Chức vụ mới',
        new_position_name: 'Chức vụ mới',
        newPosition: 'Chức vụ mới',
        toPosition: 'Chức vụ mới',
        reason: 'Lý do',
        lyDo: 'Lý do',
        ly_do: 'Lý do',
        note: 'Ghi chú',
        ghiChu: 'Ghi chú',
        ghi_chu: 'Ghi chú'
      };

      const orderedKeys = [
        'decisionNo', 'decision_no', 'soQuyetDinh', 'so_quyet_dinh',
        'rotationDate', 'rotation_date', 'ngayDieuChuyen', 'ngay_dieu_chuyen', 'effectDate', 'effect_date', 'applyDate', 'apply_date', 'date',
        'oldDepartmentName', 'old_department_name', 'oldDeptName', 'old_dept_name', 'oldDepartment', 'fromDepartment',
        'newDepartmentName', 'new_department_name', 'newDeptName', 'new_dept_name', 'newDepartment', 'toDepartment',
        'oldPositionName', 'old_position_name', 'oldPosition', 'fromPosition',
        'newPositionName', 'new_position_name', 'newPosition', 'toPosition',
        'reason', 'lyDo', 'ly_do', 'note', 'ghiChu', 'ghi_chu'
      ];

      // Extract all keys present in the data
      const presentKeys = new Set();
      this.rotationHistory.forEach(item => {
        Object.keys(item).forEach(k => {
          if (k !== 'id' && k !== 'employeeCode' && k !== 'employeecode' && k !== 'employee_code' && k !== 'employeeName' && k !== 'employeename' && k !== 'employee_name') {
            presentKeys.add(k);
          }
        });
      });

      // Build headers in the preferred order
      const headers = [];
      orderedKeys.forEach(key => {
        if (presentKeys.has(key)) {
          headers.push({
            text: labelMap[key],
            value: key
          });
          presentKeys.delete(key);
        }
      });

      // Append remaining keys
      presentKeys.forEach(key => {
        headers.push({
          text: labelMap[key] || key,
          value: key
        });
      });

      return headers;
    }
  },

  data() {
    return {
      users: [],
      selectItem: {},
      search: "",
      headers: [
        {text: 'Mã NS', value: 'employeeCode'},
        {text: 'Tên NS', value: 'employeeName'},
        {text: 'Khối', value: 'departmentTypeName'},
        {text: 'Phòng/Chi nhánh', value: 'departmentName'},
        {text: 'Chức danh', value: 'positionStateName'},
        {text: 'Tài khoản', value: 'userName'},
        {text: 'Trại thái nhân viên', value: 'employeeStatus'},
        {text: 'Trạng thái tài khoản', value: 'userStatus'},
        {text: 'Hành động', value: 'actions'}
      ],

      // menu and dialog
      rClickMenu: false,
      rClickMenuX: 0,
      rClickMenuY: 0,

      //dialog IP
      ipDialog: false,
      ipList: '',
      formIp: {
        ip1: '',
        ip2: '',
        ip3: ''
      },

      //cfmDialog
      cfmDialog: false,

      changePasswordDialog: false,
      itChangePasswordValid: false,
      changePasswordForm: {
        password: '',
        confirmPassword: '',
        oldPassword: 'oldpass'
      },

      rotationDialog: false,
      rotationLoading: false,
      rotationHistory: []
    }
  },
  methods: {
    setFaceAllow(item) {
      return this.userService.setFaceValid(item.userCode)
    },

    rowRightClickHandler(e, select) {
      this.rClickMenuX = e.clientX
      this.rClickMenuY = e.clientY
      this.rClickMenu = true
      this.selectItem = select.item
    },

    openIpDialogHandler() {
      this.ipDialog = true
      this.departmentService.getDeptIp(this.selectItem.code).then(d => {
        this.ipList = d
        let ipArr = this.ipList.split(',')
        this.formIp.ip1 = ipArr[0]
        this.formIp.ip2 = ipArr[1]
        this.formIp.ip3 = ipArr[2]
      })
    },

    closeIpDialogHandler() {
      this.selectItem = {}
      this.ipDialog = false
    },

    addWebHandler(item){
      console.log(item)
      return this.userService.addWeb(item.userCode)
    },

    changePasswordHandler(){
      this.$refs.it_change_password.validate();
      if(this.itChangePasswordValid){
        return this.userService.changePassword(this.selectItem.userCode, this.changePasswordForm).finally(() => {
          this.itChangePasswordValid = false
          this.changePasswordDialog = false
        })
      }
    },

    formatDate(value) {
      if (!value) return '';
      if (typeof moment !== 'undefined') {
        return moment(value).format("DD/MM/YYYY");
      }
      try {
        const date = new Date(value);
        if (isNaN(date.getTime())) return value;
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
      } catch (e) {
        return value;
      }
    },

    showRotationHistory(item) {
      this.selectItem = item;
      this.rotationLoading = true;
      this.rotationHistory = [];
      this.rotationDialog = true;
      
      this.userService.getRotationDetails(item.employeeCode)
        .then(d => {
          if (Array.isArray(d)) {
            this.rotationHistory = d;
          } else if (d && Array.isArray(d.data)) {
            this.rotationHistory = d.data;
          } else {
            this.rotationHistory = [];
          }
        })
        .catch(err => {
          console.error(err);
          this.rotationHistory = [];
        })
        .finally(() => {
          this.rotationLoading = false;
        });
    }
  },

  userService: null,
  created() {
    this.userService = new UserService();
  },
  mounted() {
    this.userService.gets().then(d => this.users=d)
  }
  
}
</script>